module.exports = __webpack_public_path__ + "static/media/cifar6.42304f64.png";